import { render, staticRenderFns } from "./ListCotacoes.vue?vue&type=template&id=28296baa&"
import script from "./ListCotacoes.vue?vue&type=script&lang=js&"
export * from "./ListCotacoes.vue?vue&type=script&lang=js&"
import style0 from "./ListCotacoes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports